/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/Wrapper.vue';
import NotificationsView from './components/NotificationsView.vue';
import {
  LEGACY_AGENT_ONLY_PERMISSIONS,
  NOTIFICATIONS_PERMISSIONS,
} from '../../../constants/permissions';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    component: SettingsWrapper,
    props: {
      headerTitle: '',
      icon: '',
      showNewButton: false,
    },
    children: [
      {
        path: '',
        name: 'notifications_index',
        component: NotificationsView,
        meta: {
          permissions: {
            anyOf: [
              'administrator',
              LEGACY_AGENT_ONLY_PERMISSIONS,
              NOTIFICATIONS_PERMISSIONS,
            ],
          },
        },
      },
    ],
  },
];
